import { apiFetch } from "./apiClient";

// TO DO - resolve similar url paths from frontend and api-service
export async function getAllJobs({ startDate, endDate } = {}) {
  const params = new URLSearchParams();
  if (startDate) params.set("start_date", startDate);
  if (endDate) params.set("end_date", endDate);

  const query = params.toString() ? `?${params.toString()}` : "";
  const res = await apiFetch(`/api/services/jobs/get-all${query}`);
  if (!res.ok) {
    throw new Error("Failed to fetch jobs");
  }
  console.log("getAllJobs response:", res);
  return res.json();
}

export async function getJobById(jobId) {
  const res = await apiFetch(`/api/services/jobs/${jobId}`);
  if (!res.ok) {
    throw new Error("Failed to fetch job");
  }
  return res.json();
}

export async function createJob(jobData) {
  const res = await apiFetch("/api/services/jobs/create-job", {
    method: "POST",
    body: JSON.stringify(jobData),
  });
  if (!res.ok) {
    const errorData = await res.json();
    throw new Error(errorData.error || "Failed to create job");
  }
  return res.json();
}

export async function updateJob(jobId, updates) {
  const res = await apiFetch(`/api/services/jobs/${jobId}`, {
    method: "PUT",
    body: JSON.stringify(updates),
  });
  if (!res.ok) {
    const errorData = await res.json().catch(() => ({}));
    throw new Error(errorData.error || "Failed to update job");
  }
  return res.json();
}
